export const translations = {
  fr: {
    // Header
    header: {
      services: "Services",
      moyens: "Moyens",
      confidentiality: "Confidentialité",
      contact: "Contact",
      cta: "Demande d'Information"
    },

    // Hero
    hero: {
      title: "ALTES",
      titleSmall: "PROTECTION",
      mainSubtitle: "Protection Rapprochée de Haut Niveau (Executive Protection)",
      subtitle: "Service exclusif pour personnalités internationales",
      locations: {
        paris: "Paris",
        monaco: "Monaco"
      },
      cta: "Demande d'Information"
    },

    // About Section
    about: {
      text1: "ALTES Protection est une société spécialisée dans la protection rapprochée et la sécurité des personnalités en France, à Monaco et à l'international.",
      text2: "Elle est née du regroupement de plusieurs expertises afin d'offrir à nos clients une structure solide, capable d'intervenir dans les environnements les plus exigeants.",
      text3: "Nous accompagnons dirigeants, investisseurs, familles privées et personnalités publiques dans leurs déplacements et leur quotidien.",
      text4: "Chaque mission est conçue sur mesure et peut inclure : protection physique, analyse des risques, coordination sécuritaire et mobilité sécurisée avec chauffeurs spécialisés.",
      text5: "Nos agents opèrent avec une discrétion absolue et un respect total de la confidentialité."
    },

    // Global Presence
    globalPresence: {
      title: "Présence Internationale",
      text1: "Nos équipes interviennent dans les principales capitales internationales telles que Paris, Monaco, Genève, Londres, Milan, Dubaï ou New York.",
      text2: "Lorsque nécessaire, nous collaborons avec des partenaires locaux rigoureusement sélectionnés afin de garantir un niveau de prestation homogène à l'international.",
      text3: "Nos équipes opèrent quotidiennement pour des dirigeants de premier plan et des personnalités exposées à des environnements à risque élevé.",
      cities: "Villes d'intervention",
      stats: {
        cities: "Villes Couvertes",
        continents: "Continents",
        availability: "Disponibilité",
        confidentiality: "Confidentialité"
      }
    },

    // Confidentiality
    confidentiality: {
      title: "La Confidentialité\nComme Priorité Absolue",
      description: "Tous nos agents sont soumis à des accords de confidentialité stricts (NDA). Aucune information relative à nos clients ou à nos opérations n'est divulguée. La discrétion fait partie intégrante de notre engagement."
    },

    // Services
    services: {
      title: "Nos Services",
      subtitle: "Une expertise reconnue au service de la confidentialité et de la sécurité de nos clients",
      
      cpo: {
        number: "01",
        title: "Protection Rapprochée",
        subtitle: "Close Protection Officer (CPO) - Executive Protection",
        description: "Nos agents sont formés aux plus hauts standards internationaux. Service exclusif pour clients individuels. Disponibilité 24/7 sur terre, dans les airs et en mer."
      },

      risk: {
        number: "02",
        title: "Risk Assessment",
        subtitle: "Évaluation des Risques",
        description: "Analyse complète des menaces pour chaque mission. Audits généraux sur la personnalité et son environnement proche. Identification et traitement des agresseurs, stalkers et paparazzis. Protection proactive adaptée à chaque situation."
      },

      supervision: {
        number: "03",
        title: "Supervision",
        subtitle: "Coordination Préalable",
        description: "Reconnaissances préalables systématiques de tous les lieux de mission. Planification minutieuse des itinéraires et identification des zones à risque. Coordination stratégique pointue avec agents de terrain pour anticiper chaque détail. Supervision des chauffeurs et APR. Point de contact unique pour une communication optimale."
      }
    },

    // Moyens
    moyens: {
      title: "Nos Moyens",
      subtitle: "Infrastructure complète et ressources professionnelles pour garantir une protection optimale",

      coordination: {
        number: "04",
        title: "Coordination",
        subtitle: "TOC 24/7",
        description: "Interlocuteur unique pour toutes vos missions. Coordination et suivi en temps réel depuis notre centre opérationnel de Suresnes. Monitoring continu 24/7j de toutes nos missions sur le terrain. Support de notre flotte Limousine pour d'éventuelles extractions rapides. Rapports et analyses instantanés."
      },

      formation: {
        number: "05",
        title: "Formation",
        subtitle: "Excellence & Certification",
        description: "Tous nos agents sont formés et suivis par SF3 Pro, organisme certifié spécialisé dans la formation des professionnels de la sécurité privée. Formation continue aux dernières techniques de protection rapprochée, premiers secours de crise et contre-surveillance."
      },

      vehicules: {
        number: "06",
        title: "Véhicules Blindés",
        subtitle: "Flotte Premium",
        description: "Flotte de véhicules blindés haut de gamme disponible pour toutes vos missions. Véhicules discrets ou ostentatoires selon vos besoins. Chauffeurs formés à la conduite sécurisée et aux protocoles d'évacuation d'urgence."
      }
    },

    // Confidentiality
    // Confidentiality
    confidentiality: {
      title: "La Confidentialité\nComme Priorité Absolue",
      description: "Tous nos agents sont soumis à des accords de confidentialité stricts (NDA). Aucune information relative à nos clients ou à nos opérations n'est divulguée. La discrétion fait partie intégrante de notre engagement."
    },

    // Excellence Notice
    excellence: {
      text: "Dans une logique d'excellence, nous pouvons être amenés à décliner certaines missions si les conditions ne permettent pas d'en garantir une exécution optimale."
    },

    // Missions Carousel
    missions: {
      title: "Nos Missions"
    },

    // Contact
    contact: {
      title: "Demande d'Information",
      subtitle: "Contactez-nous pour une évaluation confidentielle de vos besoins. Réponse rapide et strictement confidentielle.",
      form: {
        name: "Nom complet",
        email: "Email",
        phone: "Téléphone",
        phoneInvalid: "Numéro de téléphone invalide",
        message: "Message",
        submit: "Envoyer",
        sending: "Envoi...",
        success: "Message envoyé avec succès",
        error: "Erreur lors de l'envoi"
      }
    },

    // Confidentiality Page
    confidentialityPage: {
      title: "Politique de Confidentialité",
      subtitle: "La protection de vos données personnelles et la confidentialité de nos échanges constituent le fondement de notre engagement.",
      backHome: "Retour à l'accueil",
      contact: "Pour toute question relative à cette politique de confidentialité, contactez-nous à info@altes-protection.com",
      sections: [
        {
          title: "1. Engagements de Confidentialité",
          content: [
            "ALTES Protection s'engage à garantir la confidentialité absolue de toute information concernant ses clients, ses opérations et ses missions.",
            "Tous nos agents et collaborateurs sont soumis à des accords de confidentialité stricts (NDA) et sont formés aux protocoles de protection des données les plus exigeants.",
            "Nous n'effectuons aucune communication publique concernant nos clients ou nos interventions. La discrétion opérationnelle est au cœur de notre métier."
          ]
        },
        {
          title: "2. Collecte et Utilisation des Données",
          content: [
            "Dans le cadre de nos prestations de protection rapprochée et de sécurité, nous pouvons être amenés à collecter et traiter des données personnelles vous concernant : identité, coordonnées, habitudes de déplacement, environnement professionnel ou familial.",
            "Ces informations sont collectées uniquement dans le but d'assurer votre protection et la qualité de nos services. Elles ne sont jamais partagées avec des tiers, sauf obligation légale stricte.",
            "Vos données sont stockées de manière sécurisée et ne sont accessibles qu'aux membres de notre équipe directement impliqués dans votre protection."
          ]
        },
        {
          title: "3. Protection et Sécurisation",
          content: [
            "Nous mettons en œuvre des mesures techniques et organisationnelles avancées pour protéger vos données contre tout accès non autorisé, perte, altération ou divulgation.",
            "Nos systèmes d'information sont régulièrement audités et notre personnel est formé aux meilleures pratiques en matière de cybersécurité et de confidentialité opérationnelle."
          ]
        },
        {
          title: "4. Durée de Conservation",
          content: [
            "Vos données sont conservées uniquement pendant la durée nécessaire à l'exécution de nos missions et au respect de nos obligations légales.",
            "À l'issue de notre collaboration, et sauf demande contraire de votre part, vos informations sont archivées de manière sécurisée ou détruites conformément aux réglementations en vigueur."
          ]
        },
        {
          title: "5. Vos Droits",
          content: [
            "Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité de vos données personnelles.",
            "Vous pouvez exercer ces droits à tout moment en nous contactant à l'adresse : info@altes-protection.com"
          ]
        },
        {
          title: "6. Cookies",
          content: [
            "Avec votre accord, ce site utilise des cookies de mesure d'audience (Google Analytics) et de publicité (Google Ads) pour comprendre comment il est consulté et mesurer l'efficacité de nos annonces. Aucun de ces cookies n'est déposé si vous les refusez.",
            "Votre choix est conservé 6 mois. Vous pouvez le modifier à tout moment grâce au lien « Gérer les cookies » en bas de chaque page."
          ]
        },
        {
          title: "7. Modifications",
          content: [
            "Cette politique de confidentialité peut être mise à jour pour refléter les évolutions de nos pratiques ou de la réglementation.",
            "Toute modification substantielle vous sera communiquée directement."
          ]
        }
      ]
    },

    // Footer
    footer: {
      company: {
        title: "ALTES",
        titleSmall: "PROTECTION",
        description: "Protection d'excellence et confidentialité absolue pour nos clients. Opérations en France, à Monaco et à l'international.",
        cnaps: "CNAPS : Autorisation d'exercice n° 2026-0070492-AUT-1088774"
      },
      services: {
        title: "Services",
        cpo: "Protection Rapprochée",
        risk: "Évaluation des Risques",
        formation: "Formation",
        cctv: "CCTV 24/7"
      },
      contact: {
        title: "Contact",
        paris: "Paris",
        monaco: "Monaco"
      },
      legal: {
        copyright: "© 2026 ALTES PROTECTION. Tous droits réservés."
      }
    },

    // Pages individuelles - CPO
    cpo: {
      title: "Protection Rapprochée",
      subtitle: "Excellence & Discrétion opérationnelle",
      intro: "Agents titulaires de la carte professionnelle A3P (France). Formés à nos protocoles internes ainsi qu'aux standards internationaux de l'Executive Protection.",
      excellence: {
        title: "Protection rapprochée haut de gamme – ALTES Protection",
        text1: "Notre approche repose sur l'anticipation, l'analyse comportementale et le profilage tactique.",
        text2: "Chaque agent est sélectionné selon un processus exigeant, privilégiant la capacité d'évaluation des menaces, la maîtrise environnementale et une intelligence situationnelle avancée.",
        text3: "Nous intervenons auprès de dirigeants, d'investisseurs et de personnalités exposées, en France (Paris, Monaco) comme à l'international."
      },
      disponibilite: {
        title: "Maîtrise opérationnelle",
        text: "Au-delà de la protection physique, nos équipes intègrent des compétences avancées en gestion de crise et en médecine d'urgence opérationnelle (medic bag). Chaque dispositif est conçu pour répondre à des environnements à risque élevé, avec une capacité d'adaptation immédiate."
      },
      global: {
        title: "Disponibilité globale",
        text: "Présence opérationnelle continue, en France, en Europe et à l'international. Déploiement discret, quel que soit le contexte : déplacements privés, événements sensibles ou environnements complexes."
      }
    },

    // Risk Assessment
    riskAssessment: {
      title: "Risk Assessment",
      subtitle: "Risk Assessment",
      intro: "Évaluation complète et proactive des menaces pour garantir votre sécurité.",
      analyse: {
        title: "Analyse approfondie",
        text1: "Nous réalisons une évaluation complète et confidentielle des risques liés à votre environnement, vos déplacements et votre exposition.",
        text2: "Notre approche repose sur l'analyse comportementale, l'étude des menaces potentielles et l'identification des vulnérabilités.",
        text3: "Chaque dispositif est conçu sur mesure afin d'adapter précisément les moyens humains et opérationnels à votre profil."
      },
      approche: {
        title: "Approche opérationnelle",
        text: "Nos équipes s'appuient sur des méthodes éprouvées d'Executive Protection pour anticiper, détecter et neutraliser les risques avant qu'ils ne se matérialisent. Lorsque nécessaire, nous collaborons avec des experts techniques certifiés afin d'intégrer des dispositifs de sécurisation adaptés (audit électronique, sécurisation des communications, contrôle des environnements sensibles)."
      },
      evaluation: {
        title: "Évaluation stratégique",
        text: "Nos analyses permettent d'établir une lecture claire du niveau d'exposition et des menaces, afin d'orienter les décisions sécuritaires de manière pragmatique et proportionnée."
      }
    },

    // Coordination / Supervision
    coordination: {
      title: "Supervision",
      subtitle: "Supervision",
      intro: "Supervision opérationnelle – ALTES Protection. Nos équipes assurent la préparation, la coordination et le suivi en temps réel de chaque mission. Chaque dispositif fait l'objet de reconnaissances préalables systématiques, d'une planification précise des itinéraires et d'une analyse des zones sensibles.",
      coordination: {
        title: "Coordination terrain",
        text: "Nous orchestrons l'ensemble des intervenants impliqués dans la mission : agents de protection rapprochée, chauffeurs spécialisés, équipes locales de sécurité, directions sûreté et assistants exécutifs. Chaque opération est pilotée avec un point de contact unique, garantissant une communication fluide et une exécution sans friction."
      },
      gestion: {
        title: "Gestion de missions et événements sensibles",
        text: "Nos équipes coordonnent des dispositifs de sécurité pour : déplacements à haut niveau d'exposition, événements privés ou publics, environnements complexes et internationaux. Nous assurons la synchronisation complète des acteurs, l'adaptation en temps réel et la continuité opérationnelle, quelles que soient les contraintes."
      }
    },

    // CCTV / TOC
    cctv: {
      title: "Tactical Operations Center (TOC)",
      subtitle: "Centre de commandement et de coordination 24/7",
      intro: "TOC – Centre de commandement opérationnel – ALTES Protection",
      pilotage: {
        title: "Pilotage centralisé",
        text: "Notre Tactical Operations Center, basé à Suresnes, constitue le point névralgique de l'ensemble de nos opérations. Il permet une coordination en temps réel de toutes les missions, une vision globale des dispositifs en place et une capacité d'ajustement immédiate en fonction des évolutions terrain."
      },
      coordination: {
        title: "Coordination et suivi opérationnel",
        text: "Chaque mission est suivie en continu par nos équipes, en lien direct avec les agents, chauffeurs sécurisés et coordinateurs terrain. Nous assurons la gestion des flux d'informations, la supervision des déplacements et la prise de décision rapide en cas de situation sensible."
      },
      intervention: {
        title: "Capacité d'intervention",
        text: "En cas de besoin, nos équipes sont en mesure de déclencher immédiatement des dispositifs complémentaires, incluant des moyens de mobilité sécurisée pour extraction ou repositionnement rapide."
      },
      reporting: {
        title: "Analyse et reporting",
        text: "Le TOC permet la production de rapports opérationnels et d'analyses en temps réel, garantissant une parfaite traçabilité des missions et une amélioration continue des dispositifs."
      }
    },

    // Formation
    formation: {
      title: "Formation",
      subtitle: "Exigence opérationnelle & standards internationaux",
      intro: "Formation – ALTES Protection",
      standards: {
        title: "Standards de formation",
        text: "Tous nos agents suivent un programme de formation continue structuré, combinant exigences internes et enseignements délivrés par des organismes spécialisés reconnus, dont SF3 Pro. Cette approche garantit un niveau de préparation homogène et adapté aux environnements à forte exigence opérationnelle."
      },
      preparation: {
        title: "Préparation opérationnelle",
        text: "Nos formations couvrent l'ensemble des compétences nécessaires à l'Executive Protection moderne : techniques avancées de protection rapprochée, gestion de crise et extraction, contre-surveillance et détection de menaces, premiers secours en situation dégradée (trauma care), utilisation opérationnelle des équipements médicaux (medic bag). Les entraînements sont réalisés en conditions réalistes afin de préparer nos agents à intervenir efficacement dans des contextes complexes et évolutifs."
      },
      continue: {
        title: "Formation continue",
        text: "Nos équipes sont régulièrement remises à niveau afin d'intégrer les dernières évolutions du métier et de maintenir un haut niveau d'exigence. Chaque agent est suivi dans le temps, avec une attention particulière portée à sa capacité d'analyse, sa gestion du stress et son comportement en environnement sensible."
      },
      partenariats: {
        title: "Partenariats spécialisés",
        text: "Nous collaborons avec des organismes de formation reconnus pour leur expertise dans la sécurité privée et la protection rapprochée."
      }
    },

    // Véhicules / Mobilité
    vehicules: {
      title: "Mobilité sécurisée & moyens opérationnels",
      subtitle: "Intégration de solutions de transport dans les dispositifs de protection",
      intro: "Mobilité sécurisée – ALTES Protection",
      integration: {
        title: "Intégration opérationnelle",
        text: "Dans le cadre de nos missions de protection rapprochée, nous mobilisons des solutions de mobilité adaptées aux exigences sécuritaires et opérationnelles. Ces moyens s'intègrent directement dans le dispositif global afin d'assurer des déplacements maîtrisés, fluides et sécurisés."
      },
      dispositifs: {
        title: "Dispositifs de déplacement",
        text: "Selon le niveau de risque et la nature de la mission, nous mettons en place : véhicules sécurisés ou blindés, dispositifs multi-véhicules, solutions d'extraction ou de repositionnement, coordination des flux de déplacement. Ces moyens sont activés uniquement dans le cadre d'un dispositif de protection."
      },
      coordination: {
        title: "Coordination spécialisée",
        text: "Les solutions de mobilité sont opérées en coordination avec des partenaires spécialisés dans le transport premium, sélectionnés pour leur fiabilité et leur niveau d'exigence. Nos équipes assurent la supervision complète afin de garantir la cohérence entre sécurité et déplacement."
      },
      discretion: {
        title: "Discrétion et efficacité",
        text: "Chaque dispositif est adapté pour répondre à un équilibre précis entre discrétion, sécurité et efficacité opérationnelle, en fonction du profil du client et de son environnement."
      }
    }
  },

  en: {
    // Header
    header: {
      services: "Services",
      moyens: "Resources",
      confidentiality: "Confidentiality",
      contact: "Contact",
      cta: "Request Information"
    },

    // Hero
    hero: {
      title: "ALTES",
      titleSmall: "PROTECTION",
      mainSubtitle: "High-Level Close Protection (Executive Protection)",
      subtitle: "Exclusive service for international personalities",
      locations: {
        paris: "Paris",
        monaco: "Monaco"
      },
      cta: "Request Information"
    },

    // About Section
    about: {
      text1: "ALTES Protection is a company specialized in close protection and security for high-profile individuals in France, Monaco and internationally.",
      text2: "Born from the merger of several expertises to offer our clients a solid structure capable of operating in the most demanding environments.",
      text3: "We accompany executives, investors, private families and public figures in their travels and daily life.",
      text4: "Each mission is custom-designed and may include: physical protection, risk assessment, security coordination and secure mobility with specialized drivers.",
      text5: "Our agents operate with absolute discretion and total respect for confidentiality."
    },

    // Global Presence
    globalPresence: {
      title: "International Presence",
      text1: "Our teams operate in major international capitals such as Paris, Monaco, Geneva, London, Milan, Dubai and New York.",
      text2: "When necessary, we collaborate with rigorously selected local partners to ensure a consistent level of service internationally.",
      text3: "Our teams operate daily for top-tier executives and personalities exposed to high-risk environments.",
      cities: "Areas of operation",
      stats: {
        cities: "Cities Covered",
        continents: "Continents",
        availability: "Availability",
        confidentiality: "Confidentiality"
      }
    },

    // Confidentiality
    confidentiality: {
      title: "Confidentiality\nas Absolute Priority",
      description: "All our agents are bound by strict confidentiality agreements (NDA). No information regarding our clients or operations is ever disclosed. Discretion is an integral part of our commitment."
    },

    // Services
    services: {
      title: "Our Services",
      subtitle: "Recognized expertise serving the confidentiality and security of our clients",
      
      cpo: {
        number: "01",
        title: "Close Protection",
        subtitle: "Close Protection Officer (CPO) - Executive Protection",
        description: "Our agents are trained to the highest international standards. Exclusive service for individual clients. 24/7 availability on land, in the air and at sea."
      },

      risk: {
        number: "02",
        title: "Risk Assessment",
        subtitle: "Threat Evaluation",
        description: "Comprehensive threat analysis for each mission. General audits on the personality and their close environment. Identification and handling of aggressors, stalkers and paparazzi. Proactive protection adapted to each situation."
      },

      supervision: {
        number: "03",
        title: "Supervision",
        subtitle: "Advance Coordination",
        description: "Systematic advance reconnaissance of all mission locations. Meticulous route planning and risk zone identification. Strategic coordination with field agents to anticipate every detail. Supervision of drivers and CPO agents. Single point of contact for optimal communication."
      }
    },

    // Moyens
    moyens: {
      title: "Our Resources",
      subtitle: "Complete infrastructure and professional resources to guarantee optimal protection",

      coordination: {
        number: "04",
        title: "Coordination",
        subtitle: "TOC 24/7",
        description: "Single point of contact for all your missions. Real-time coordination and monitoring from our Suresnes operations center. Continuous 24/7 monitoring of all our field missions. Limousine fleet support for rapid extractions. Instant reports and analysis."
      },

      formation: {
        number: "05",
        title: "Training",
        subtitle: "Excellence & Certification",
        description: "All our agents are trained and monitored by SF3 Pro, a certified organization specialized in training private security professionals. Continuous training in the latest close protection techniques, crisis first aid and counter-surveillance."
      },

      vehicules: {
        number: "06",
        title: "Armored Vehicles",
        subtitle: "Premium Fleet",
        description: "Fleet of high-end armored vehicles available for all your missions. Discreet or ostentatious vehicles according to your needs. Drivers trained in secure driving and emergency evacuation protocols."
      }
    },

    // Confidentiality
    confidentiality: {
      title: "Absolute Confidentiality",
      description: "All our agents sign strict confidentiality agreements (NDA). No information about our clients or missions is ever disclosed. Total protection of your privacy and image."
    },

    // Excellence Notice
    excellence: {
      text: "In a logic of excellence, we may decline certain missions if conditions do not allow us to guarantee optimal execution."
    },

    // Missions Carousel
    missions: {
      title: "Our Missions"
    },

    // Contact
    contact: {
      title: "Request Information",
      subtitle: "Contact us for a confidential assessment of your needs. Fast response and strictly confidential.",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        phoneInvalid: "Invalid phone number",
        message: "Message",
        submit: "Send",
        sending: "Sending...",
        success: "Message sent successfully",
        error: "Error sending message"
      }
    },

    confidentialityPage: {
      title: "Privacy Policy",
      subtitle: "Protecting your personal data and keeping our exchanges confidential are the foundation of our commitment.",
      backHome: "Back to home",
      contact: "For any question about this privacy policy, contact us at info@altes-protection.com",
      sections: [
        {
          title: "1. Confidentiality Commitments",
          content: [
            "ALTES Protection is committed to guaranteeing the absolute confidentiality of all information concerning its clients, operations and missions.",
            "All our agents and staff are bound by strict non-disclosure agreements (NDA) and trained in the most demanding data protection protocols.",
            "We never make any public statement about our clients or our assignments. Operational discretion is at the heart of what we do."
          ]
        },
        {
          title: "2. Data Collection and Use",
          content: [
            "As part of our close protection and security services, we may collect and process personal data about you: identity, contact details, travel habits, professional or family environment.",
            "This information is collected solely to ensure your protection and the quality of our services. It is never shared with third parties, except where strictly required by law.",
            "Your data is stored securely and is only accessible to the members of our team directly involved in your protection."
          ]
        },
        {
          title: "3. Protection and Security",
          content: [
            "We implement advanced technical and organisational measures to protect your data against unauthorised access, loss, alteration or disclosure.",
            "Our information systems are audited regularly and our staff are trained in best practices for cybersecurity and operational confidentiality."
          ]
        },
        {
          title: "4. Retention Period",
          content: [
            "Your data is kept only for as long as necessary to carry out our missions and to meet our legal obligations.",
            "At the end of our collaboration, and unless you request otherwise, your information is securely archived or destroyed in accordance with applicable regulations."
          ]
        },
        {
          title: "5. Your Rights",
          content: [
            "Under the General Data Protection Regulation (GDPR), you have the right to access, rectify, erase and port your personal data.",
            "You may exercise these rights at any time by contacting us at: info@altes-protection.com"
          ]
        },
        {
          title: "6. Cookies",
          content: [
            "With your consent, this website uses audience measurement (Google Analytics) and advertising (Google Ads) cookies to understand how it is used and measure how well our ads perform. None of these cookies is set if you reject them.",
            "Your choice is kept for 6 months. You can change it at any time using the “Manage cookies” link at the bottom of every page."
          ]
        },
        {
          title: "7. Changes",
          content: [
            "This privacy policy may be updated to reflect changes in our practices or in the regulations.",
            "Any substantial change will be communicated to you directly."
          ]
        }
      ]
    },

    // Footer
    footer: {
      company: {
        title: "ALTES",
        titleSmall: "PROTECTION",
        description: "Excellence protection and absolute confidentiality for our clients. Operations in France, Monaco and worldwide.",
        cnaps: "CNAPS: Operating authorization n° 2026-0070492-AUT-1088774"
      },
      services: {
        title: "Services",
        cpo: "Close Protection",
        risk: "Risk Assessment",
        formation: "Training",
        cctv: "CCTV 24/7"
      },
      contact: {
        title: "Contact",
        paris: "Paris",
        monaco: "Monaco"
      },
      legal: {
        copyright: "© 2026 ALTES PROTECTION. All rights reserved."
      }
    },

    // Pages individuelles - CPO
    cpo: {
      title: "Close Protection",
      subtitle: "Excellence & Operational Discretion",
      intro: "Agents holding the professional A3P card (France). Trained in our internal protocols as well as international Executive Protection standards.",
      excellence: {
        title: "High-end close protection – ALTES Protection",
        text1: "Our approach is based on anticipation, behavioral analysis and tactical profiling.",
        text2: "Each agent is selected through a demanding process, favoring threat assessment capabilities, environmental mastery and advanced situational intelligence.",
        text3: "We work with executives, investors and exposed personalities, in France (Paris, Monaco) and internationally."
      },
      disponibilite: {
        title: "Operational Mastery",
        text: "Beyond physical protection, our teams integrate advanced skills in crisis management and operational emergency medicine (medic bag). Each operation is designed to respond to high-risk environments, with immediate adaptability."
      },
      global: {
        title: "Global Availability",
        text: "Continuous operational presence in France, Europe and internationally. Discreet deployment, regardless of context: private travel, sensitive events or complex environments."
      }
    },

    // Risk Assessment
    riskAssessment: {
      title: "Risk Assessment",
      subtitle: "Risk Assessment",
      intro: "Comprehensive and proactive threat assessment to ensure your security.",
      analyse: {
        title: "In-Depth Analysis",
        text1: "We conduct a comprehensive and confidential assessment of risks related to your environment, travel and exposure.",
        text2: "Our approach is based on behavioral analysis, study of potential threats and identification of vulnerabilities.",
        text3: "Each system is custom-designed to precisely adapt human and operational resources to your profile."
      },
      approche: {
        title: "Operational Approach",
        text: "Our teams rely on proven Executive Protection methods to anticipate, detect and neutralize risks before they materialize. When necessary, we collaborate with certified technical experts to integrate appropriate security systems (electronic audit, communications security, sensitive environment control)."
      },
      evaluation: {
        title: "Strategic Assessment",
        text: "Our analyses provide a clear understanding of exposure levels and threats, enabling pragmatic and proportionate security decision-making."
      }
    },

    // Coordination / Supervision
    coordination: {
      title: "Supervision",
      subtitle: "Supervision",
      intro: "Operational supervision – ALTES Protection. Our teams ensure preparation, coordination and real-time monitoring of each mission. Each operation undergoes systematic preliminary reconnaissance, precise route planning and analysis of sensitive areas.",
      coordination: {
        title: "Field Coordination",
        text: "We orchestrate all stakeholders involved in the mission: close protection agents, specialized drivers, local security teams, security management and executive assistants. Each operation is managed with a single point of contact, ensuring smooth communication and seamless execution."
      },
      gestion: {
        title: "Mission and Sensitive Event Management",
        text: "Our teams coordinate security systems for: high-exposure travel, private or public events, complex and international environments. We ensure complete synchronization of actors, real-time adaptation and operational continuity, regardless of constraints."
      }
    },

    // CCTV / TOC
    cctv: {
      title: "Tactical Operations Center (TOC)",
      subtitle: "24/7 Command and Coordination Center",
      intro: "TOC – Operational Command Center – ALTES Protection",
      pilotage: {
        title: "Centralized Management",
        text: "Our Tactical Operations Center, based in Suresnes, is the nerve center of all our operations. It enables real-time coordination of all missions, global visibility of deployed systems and immediate adjustment capabilities based on field developments."
      },
      coordination: {
        title: "Coordination and Operational Monitoring",
        text: "Each mission is continuously monitored by our teams, in direct contact with agents, secure drivers and field coordinators. We manage information flows, supervise movements and make rapid decisions in sensitive situations."
      },
      intervention: {
        title: "Intervention Capability",
        text: "When needed, our teams can immediately deploy additional resources, including secure mobility assets for extraction or rapid repositioning."
      },
      reporting: {
        title: "Analysis and Reporting",
        text: "The TOC enables production of operational reports and real-time analysis, ensuring complete mission traceability and continuous improvement of systems."
      }
    },

    // Formation
    formation: {
      title: "Training",
      subtitle: "Operational Excellence & International Standards",
      intro: "Training – ALTES Protection",
      standards: {
        title: "Training Standards",
        text: "All our agents follow a structured continuous training program, combining internal requirements and teachings delivered by recognized specialized organizations, including SF3 Pro. This approach ensures a consistent level of preparation adapted to high operational demand environments."
      },
      preparation: {
        title: "Operational Preparation",
        text: "Our training covers all skills necessary for modern Executive Protection: advanced close protection techniques, crisis management and extraction, counter-surveillance and threat detection, first aid in degraded situations (trauma care), operational use of medical equipment (medic bag). Training is conducted in realistic conditions to prepare our agents to intervene effectively in complex and evolving contexts."
      },
      continue: {
        title: "Continuous Training",
        text: "Our teams are regularly updated to integrate the latest developments in the profession and maintain a high level of excellence. Each agent is monitored over time, with particular attention paid to analytical capabilities, stress management and behavior in sensitive environments."
      },
      partenariats: {
        title: "Specialized Partnerships",
        text: "We collaborate with training organizations recognized for their expertise in private security and close protection."
      }
    },

    // Véhicules / Mobilité
    vehicules: {
      title: "Secure Mobility & Operational Resources",
      subtitle: "Integration of transport solutions in protection systems",
      intro: "Secure Mobility – ALTES Protection",
      integration: {
        title: "Operational Integration",
        text: "As part of our close protection missions, we deploy mobility solutions adapted to security and operational requirements. These resources integrate directly into the overall system to ensure controlled, smooth and secure movements."
      },
      dispositifs: {
        title: "Deployment Systems",
        text: "Depending on risk level and mission nature, we implement: secure or armored vehicles, multi-vehicle systems, extraction or repositioning solutions, movement flow coordination. These resources are activated only as part of a protection system."
      },
      coordination: {
        title: "Specialized Coordination",
        text: "Mobility solutions are operated in coordination with partners specialized in premium transport, selected for their reliability and standards. Our teams ensure complete supervision to guarantee consistency between security and movement."
      },
      discretion: {
        title: "Discretion and Efficiency",
        text: "Each system is adapted to achieve a precise balance between discretion, security and operational efficiency, based on client profile and environment."
      }
    }
  }
};

// Hook pour utiliser les traductions
export const useTranslations = () => {
  // Import dynamique du contexte pour éviter les imports circulaires
  const { language } = require('../contexts/LanguageContext').useLanguage();
  return translations[language] || translations.fr;
};
